import React from 'react';
import { component_tool, utils_tool } from '@/tool';
const { WizInput } = component_tool
const { isType } = utils_tool

class NumberInput extends React.Component {
  constructor(props) {
    super(props);
  }

  handleChange = (e) => {
    if(e.target.value.length>5)e.target.value=e.target.value.slice(0,10)
    this.triggerChange({ value: e.target.value });
  }

  triggerChange = changedValue => {
    const { onChange, value } = this.props;
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  render() {
    const { value } = this.props
    return (
      <div className='col-input-box'>
        <WizInput type='number' className='col-input-width' value={value.value} onChange={this.handleChange} />
        <span className='col-input-after'>{this.props.after}</span>
      </div>
    )
  }
}

class TextInput extends React.Component {
  constructor(props) {
    super(props);
  }

  handleChange = (e) => {
    this.triggerChange({ value: e.target.value.replace(/\s*/g, '') });
  }

  triggerChange = changedValue => {
    const { onChange, value } = this.props;
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  render() {
    const { value } = this.props
    return (<WizInput.TextArea className='text-area' onChange={this.handleChange} value={value.value} maxLength={100} />
    )
  }
}

class RenderTwoInput extends React.Component {

  handleBeforChange = e => {
    const { value } = this.props;
    if(e.target.value.length>5)e.target.value=e.target.value.slice(0,10)
    this.triggerChange({
      ...value,
      valueBefor: e.target.value
    });
  };

  handleAfteroChange = e => {
    const { value } = this.props;
    if(e.target.value.length>5)e.target.value=e.target.value.slice(0,10)
    this.triggerChange({
      ...value,
      valueAfter: e.target.value
    });
  };

  triggerChange = changedValue => {
    const { onChange, value } = this.props;
    const { valueBefor, valueAfter } = changedValue
    if (valueBefor && valueAfter) {
      changedValue.value = `${valueBefor}/${valueAfter}`
    } else {
      changedValue.value = ''
    }
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  render() {
    const { value } = this.props
    return (
      <>
      <div className='col-input-box'>
        <WizInput type='number' className='col-input-width' value={value.valueBefor} onChange={this.handleBeforChange} />
        <span className='col-input-after'>/</span>
        <WizInput type='number' className='col-input-width' value={value.valueAfter} onChange={this.handleAfteroChange} />
        {/* <span className='col-input-after'>（"/"前为实际数值,后为目标数值）</span> */}
      </div>
      <font style={{ 'color': 'red' }}>注:"/"前为实际数值,后为目标数值</font>
      </>
    )
  }
}


/**
 * 匹配输入框类型
 * @param {} type 
 * 0 正整数、1 百分比、 2 文字 、 3 百分比,x/y
 */
let matchInputType = (valueType) => {
  switch (valueType) {
    case 0:
      return <NumberInput />
    case 1:
      return <NumberInput after='%' />
    case 2:
      return <TextInput />
    case 3:
      return <RenderTwoInput />
    case 4:
      return <NumberInput />
    default:
      break
  }
}

/**
 * 自定义校验规则,都为必填
 * 
 */

let validatorVal = (rule, value, callback, item) => {
  let { value: inputValue } = value
  let { valueType, name } = item
  if (inputValue) {
    // 正整数
    if (valueType === 0) {
      let reg = new RegExp(/^[1-9]([0-9]*)\d*$/, 'g')
      if (!reg.test(inputValue)) {
        callback(`${name}必须为正整数`)
      }
    }
    // 百分比
    if (valueType === 1) {
      let reg = new RegExp(/^(?:[1-9]\d*|0)?(?:\.\d+)?$/)
      if (!reg.test(inputValue)) {
        callback(`${name}需为正浮点数`)
      }
      // if (inputValue < 0) {
      //   callback(`${name}不能小于零`)
      // }
    }
    // 百分比,x/y
    if (valueType === 3) {
      let splitVal = inputValue.split('/')
      // if (splitVal[0] < 0) {
      //   callback('实际数值不能小于零')
      // }
      // if (splitVal[1] <= 0) {
      //   callback('目标数字必须大于零')
      // }
      let reg = new RegExp(/^(?:[1-9]\d*|0)?(?:\.\d+)?$/)
      if (!reg.test(splitVal[0])) {
        callback(`实际数值需为正浮点数`)
      }
      if (!reg.test(splitVal[1])) {
        callback(`目标数字需为正浮点数`)
      }
    }

    // 浮点数
    if (valueType === 4) {
      let reg = new RegExp(/^(?:[1-9]\d*|0)?(?:\.\d+)?$/)
      if (!reg.test(inputValue)) {
        callback(`${name}需为正浮点数`)
      }
    }
    callback()
  } else {
    callback(`${name}不能为空或格式不符`)
  }
};

/**
 * 
 * @param {
 * } info 
 * @param {*} mapItem 
 * @returns 
 * 双input(valueType === 3) 时,重新反馈将值通过/分割
 * 新反馈 默认 satisfactionId,value valueType
 * 重新反馈,后续追加数据时,
 */
let initValueFn = (info, mapItem) => {
  let { valueType, id } = mapItem
  if (info.length) {
    let filterInfo = info.filter(e => e.satisfactionId === id)[0]
    // 重新反馈时,有后追加的内容,展示空内容
    if (!filterInfo) {
      let obj = {
        id: '',
        satisfactionId: id,
        value: '',
        valueType: valueType,
        trackKpiCycleId: info[0]['trackKpiCycleId'],
        fuseTutorId: info[0]['fuseTutorId']
      }
      if (valueType === 3) {
        return {
          ...obj,
          valueBefor: '',
          valueAfter: '',
        }
      }
      return obj
    }
    // 百分比,xy格式 原始内容 1/3, 33%  
    if (valueType === 3) {
      let arrFilterInfo = filterInfo.value.split(',')
      filterInfo.value = arrFilterInfo[0]
      let arr = arrFilterInfo[0].split('/')
      filterInfo.valueBefor = arr[0]
      filterInfo.valueAfter = arr[1]
    }
    // 百分比,去除百分号
    if (valueType === 1) {
      let arr = filterInfo.value.split('%')
      filterInfo.value = arr[0]
    }
    filterInfo.valueType = valueType
    return filterInfo
  } else {
    // 非重新反馈
    return valueType === 3 ? { satisfactionId: id, valueBefor: '', valueAfter: '', value: '', valueType } : { satisfactionId: id, value: '', valueType }
  }
}

let assembleColumns = (data = [], info = []) => {
  if (data.length === 0) {
    return []
  }
  let copyData = [...data]
  let newData = copyData.map((e, index) => {
    let { valueType, name, id } = e
    return {
      title: name,
      name: `satisfaction-${id}`,
      formItem: {
        type: 'custom',
        placeholder: `请输入${name}`,
        render: (record, form) => {
          const { getFieldDecorator } = form;
          return (
            getFieldDecorator(`satisfaction-${id}`, {
              rules: [
                { required: true, message: `请输入${name}` },
                { validator: (rule, value, callback) => validatorVal(rule, value, callback, e) }
              ],
              initialValue: initValueFn(info, e)
            })(
              matchInputType(valueType)
            )
          )
        }
      }
    }
  })
  // console.log(newData)
  return newData
}

export default assembleColumns